import React from 'react';
import ReactDOM from 'react-dom';
import LoadingSmall from '../components/LoadingSmall.js';
import Notification from './Notification';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancel;

class NewsletterListPicker extends React.Component {
    constructor(props) {
        super(props);


        this.state = {
            isWaiting:false,
            isEditing:false,
            app:0,
            list_id:0,
            list_fields:[],
            fields:this.getFields(),
            lists:[],
            hideFields:false,
            canSave:false
        }
        let c = axios.CancelToken;
        this.ct = c.source();
        this.setDefaults();

        this.onChangeApp = this.onChangeApp.bind(this);
        this.onChangeList = this.onChangeList.bind(this);
        this.renderListSelect = this.renderListSelect.bind(this);
        this.renderFieldSelect = this.renderFieldSelect.bind(this);
        this.discard = this.discard.bind(this);
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.setField = this.setField.bind(this);
        this.save = this.save.bind(this);
        this.checkIfSaveable = this.checkIfSaveable.bind(this);
    }

    setDefaults() {
        if(this.props.data.app) {
            this.state.app = this.props.data.app;
        }

        if(this.props.data.list_id) {
            this.state.list_id = this.props.data.list_id;
        }

        if(this.props.data.fields) {
            this.state.fields = this.props.data.fields;
        }
    }

    save() {
        let data = {};
        data.app = this.state.app;
        data.list_id = this.state.list_id;
        data.fields = this.state.fields;

        this.props.handleSave(data);
        this.discard();
    }

    componentWillUnmount() {
        this.ct.cancel();
    }

    checkIfSaveable() {
        let save = true;

        if(this.state.app == false || this.state.app == 0) {
            save = false;
        }

        if(this.state.list_id == false || this.state.list_id == 0) {
            save = false;
        }

        return save;
    }

    getFields() {
        let f = {};

console.dir(this.props.inputs);
        for(let i in this.props.inputs) {
            if(this.props.inputs[i].styles.placeholder) {
                f[this.props.inputs[i].id] = false;
            }

        }
        return f;
    }

    fetchLists() {

        this.setState({
            isWaiting:true,
            lists:[],
        });

        axios.get('/apps/'+this.state.app+'/lists',{
            cancelToken: this.ct.token
        })
        .then(res => {
            this.setState({isWaiting:false,lists:res.data});
        }).catch(err => {
            if(!axios.isCancel(err)) {
                Notification.error('Error fetching lists. Please try again.');
                this.setState({isWaiting:false,isEditing:false});
            }

        });
    }

    handleFieldChange(e) {
        this.setField(e.target.getAttribute('data-key'),e.target.value);
    }

    setField(key,value) {
        this.setState({
            ...this.state,
            fields:{
                ...this.state.fields,
                [key]:value
            }
        });
    }

    fetchFields() {
        this.setState({
            isWaiting:true,
            list_fields:[],
            field_id:0,
            hideFields:false,
        });
        axios.get('/apps/'+this.state.app+'/lists/'+this.state.list_id,{
            cancelToken: this.ct.token
        })
        .then(res => {
            let newState = {isWaiting:false,list_fields:res.data};

            if(res.data.length == 0) {
                newState.hideFields = true;
            }else{
                for(let i in res.data) {
                    if(res.data[i].isEmail) {
                        if(this.state.fields.email == '') {
                            this.setField('email',res.data[i].value);
                        }
                    }
                }
            }


            this.setState(newState);
        }).catch(err => {
            if(!axios.isCancel(err)) {
                Notification.error('Error fetching fields. Please try again.');
                this.setState({isWaiting:false,isEditing:false});
            }
        });
    }

    componentDidUpdate(props,state) {
        if(Object.keys(this.state.fields).length == 0) {
            this.setState({fields:this.getFields()});
        }

        if(this.state.canSave != this.checkIfSaveable()) {
            this.setState({canSave:this.checkIfSaveable()});
        }

        if(state.app != this.state.app && this.state.app != 0) {
            this.fetchLists();
        }

        if(state.list_id != this.state.list_id && this.state.list_id != 0) {
            this.fetchFields();
        }
    }

    componentDidMount() {
        if(this.state.app != 0) {
            this.fetchLists();
        }

        if(this.state.list_id != 0) {
            this.fetchFields();
        }
    }

    renderFieldSelect() {
        if(this.state.list_id == 0) {
            return null;
        }

        if(this.state.hideFields === true) {
            return null;
        }

////// HUSK!!! Push av ordrer, sidevisninger og produkter gjøres direkte mot apiet, ikke over ws
        return (
            <div className="form-group form-material floating" data-plugin="formMaterial">
                <table style={{width:'100%'}}>
                    <thead>
                        <tr>
                            <th>Popup input</th>
                            <th>Newsletter field </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            Object.keys(this.state.fields).map((key,i) => {
                                return (
                                    <tr key={i}>
                                        <td style={{width:'50%'}}>
                                            <input type="text" className="form-control" defaultValue={key.charAt(0).toUpperCase() + key.slice(1)} disabled={true} />
                                        </td>
                                        <td style={{width:'50%'}}>
                                            <select className="form-control" data-key={key} onChange={this.handleFieldChange} value={this.state.fields[key]}>
                                                <option value="0">Select field map</option>
                                                {this.state.list_fields.map(f => {
                                                    return (
                                                        <option key={f.key} value={f.key}>{f.value}</option>
                                                    )
                                                })}
                                            </select>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        );

    }

    renderListSelect() {
        if(this.state.app == 0) {
            return null;
        }

        return (
            <div className="form-group form-material floating" data-plugin="formMaterial">
                <select className="form-control" value={this.state.list_id} onChange={this.onChangeList}>
                    <option value="0">None</option>
                    {this.state.lists.map((item,i) => {
                        return <option key={i} value={item.id}>{item.name}</option>
                    })}
                </select>
                <label className="floating-label">List</label>
            </div>
        );

    }

    discard() {
        this.setState({
            isWaiting:false,
            isEditing:false
        });
    }

    onChangeApp(e) {
        this.setState({app:e.target.value});
    }

    onChangeList(e) {
        this.setState({list_id:e.target.value});
    }

    edit() {
        this.setState({isEditing:true});
    }

    render() {
        return (
            <div className="col-sm-12">
                {
                    this.state.isWaiting ?
                    <div className="locked-overlay"><LoadingSmall /></div>
                    :null
                }
                <div className="row">
                    <div className="col-sm-12">
                        {
                            !this.state.isEditing
                            ?
                            <button type="button" onClick={(e) => {e.stopPropagation(); this.edit();}} className="btn btn-dark btn-block">Configure</button>
                            :null
                        }

                        {
                            this.state.isEditing
                            ?
                            <div>
                                <div className="form-group form-material floating" data-plugin="formMaterial">
                                    <select className="form-control" value={this.state.app} onChange={this.onChangeApp}>
                                        <option value="0">None</option>
                                        {this.props.apps.map((item,i) => {
                                            return <option key={i} value={item.key}>{item.key}</option>
                                        })}
                                    </select>
                                    <label className="floating-label">App</label>
                                </div>

                                {this.renderListSelect()}
                                {this.renderFieldSelect()}

                                <div className="col-sm-6 p-l-0">
                                    <button type="button" className="btn btn-danger btn-block" onClick={this.discard}>Discard</button>
                                </div>
                                <div className="col-sm-6 p-r-0">
                                    <button type="button" className="btn btn-dark btn-block" disabled={!this.state.canSave} onClick={this.save}>Save</button>
                                </div>
                            </div>
                            :null
                        }
                    </div>
                </div>

            </div>
        );
    }
}




export default NewsletterListPicker;



// WEBPACK FOOTER //
// ./components/NewsletterListPicker.js